import { listFindMatch } from '@/function/list/list.find.match';
import type { TypeListFindConfig, TypeListFindState } from '@/types/list/types.list.find';

export const listFind = <T>(items: readonly T[], config: TypeListFindConfig<T>, state: TypeListFindState, now: Date = new Date()): T[] => {
    const kept = listFindMatch(items, config, state, now);
    const compare = config.sorts?.find((option) => option.value === state.sort)?.compare;
    if (!compare) return kept;
    const direction = state.descending ? -1 : 1;
    return kept
        .map((item, index) => ({ item, index }))
        .sort((a, b) => compare(a.item, b.item) * direction || a.index - b.index)
        .map((entry) => entry.item);
};

export default listFind;
